import { Grid, Typography } from "@mui/material";
import Policies from "./Policies";
import { useEffect, useState } from "react";
import { useNavigate } from "../utils/Router";
import * as Yup from "yup";
import { FormProvider, RHFTextField } from "../common/hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { apiConstants, postGeneric } from "../common/constants";
import { useSnackbar } from "notistack";
import { useFormData } from "../utils/formDataProvider";
import { LoadingButton } from "@mui/lab";
import { useDomainConfig } from "../utils/domainConfigProvider";
import AppConfig from "../utils/config";

function OrderDetailForm() {
  const { navigate } = useNavigate();
  const { domainConfig } = useDomainConfig();
  const isNuvah = domainConfig?.brandUrl === AppConfig?.CustomeUI?.NuvahURL;
  const phoneRegExp = /^\d{10}$/;
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [queryParams, setQueryParams] = useState({});
  const { setFormData } = useFormData();
  // const { setConfigData, setConfigLoading } = useConfig();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (let param of searchParams.entries()) {
      params['value'] = param[0];
    }
    setQueryParams(params)
  }, [])

  // useEffect(() => {
  //   if (window.location.origin) {
  //     setConfigLoading(true)
  //     // getGeneric(`${apiConstants.GET_CONFIG_DATA_BY_BRAND}?brandUrl=${window.location.origin}`).then((res) => {
  //     getGeneric(`${apiConstants.GET_CONFIG_DATA_BY_BRAND}?brandUrl=https://palettereturns.proship.in`).then((res) => {
  //       setConfigData(res.data)
  //       setConfigLoading(false)
  //     }).catch((err) => {
  //       setConfigLoading(false)
  //       console.log(err);
  //     })
  //   }
  // }, [window.location.origin])


  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        awbNumber: Yup.string().trim().required("This field is required"),
        phoneNumber: Yup.string()
          .matches(phoneRegExp, { message: 'Phone Number must be exactly 10 digits', excludeEmptyString: true })
          .min(10, 'Phone Number must be at least 10 digits')
          .required("Phone Number is required!")
      })
    ),
    defaultValues: {
      awbNumber: queryParams.value,
      phoneNumber: '',
    },
  });


  const { handleSubmit, setValue, watch } = methods;

  useEffect(() => {
    if (queryParams.value) {
      setValue('awbNumber', queryParams.value);
    }
  }, [queryParams, setValue]);

  const onSubmit = (data) => {
    setIsLoading(true)
    const payload = {
      "awbNumber": data.awbNumber,
      "phoneNumber": data.phoneNumber
    }
    postGeneric(`${apiConstants.GENERATE_OTP}`, payload).then((res) => {
      setIsLoading(false)
      if (res.data?.status !== "failed" && res.data?.tokenId) {
        navigate('/otp', res.data?.tokenId);
        enqueueSnackbar(res?.data?.message, { variant: 'success' })
        setFormData(data);
      } else {
        enqueueSnackbar(res?.data?.message, { variant: 'error' })
      }
    }).catch((err) => {
      setIsLoading(false)
      console.log(err);
      enqueueSnackbar(err?.response?.data?.message || "Some error occurred!", { variant: 'error' })
    })
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Typography variant="h6" fontWeight={500}>
            Create Return Request
          </Typography>
          <Typography variant="body2">
            Enter your information to get started.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <RHFTextField
            placeholder="Enter Order ID / AWB"
            label="Order ID / AWB *"
            name="awbNumber"
            // variant="filled"
            value={watch("awbNumber") || ''}
          />
        </Grid>
        <Grid item xs={12}>
          <RHFTextField
            placeholder="e.g. 8967676767"
            label="Phone Number *"
            name="phoneNumber"
          // variant="filled"
          />
        </Grid>
        <Grid item xs={12}>
          <LoadingButton
            loading={isLoading}
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{
              borderRadius: 2,
              ...(isNuvah && {
                bgcolor: AppConfig.CustomeUI.NuvahBrandColor,
                '&:hover': { bgcolor: AppConfig.CustomeUI.NuvahBrandColor, filter: 'brightness(0.9)' },
              }),
            }}
          >
            Generate OTP
          </LoadingButton>
        </Grid>
        <Grid item xs={12} sx={{ my: 2 }}>
          <Policies />
        </Grid>
      </Grid>
    </FormProvider>
  );
}

export default OrderDetailForm;
